<template>
    <button
      type="button"
      class="lest-talk-container"
      @click="$emit('open-contact')"
    >
      <div class="lest-talk-content">
        <h2>{{ $t("letsTalk.title") }}</h2>
        <div class="arrow-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M71.4846 18.8274C72.6935 17.6087 74.6534 17.6087 75.8622 18.8274L116.719 60.0187C117.928 61.2374 117.928 63.2133 116.719 64.432L75.8622 105.623C74.6534 106.842 72.6935 106.842 71.4846 105.623C70.2758 104.405 70.2758 102.429 71.4846 101.21L107.057 65.3461H9.46965C7.76012 65.3461 6.37427 63.9489 6.37427 62.2254C6.37427 60.5018 7.76012 59.1046 9.46965 59.1046H107.057L71.4846 23.2407C70.2758 22.022 70.2758 20.0461 71.4846 18.8274Z" class="arrow-path"/> </svg>
        </div>
      </div>
    </button>
  </template>
  
  <script>
  export default {
    name: "LetsTalk",
  };
  </script>
  
  <style scoped>
    .lest-talk-container {
      box-sizing: border-box;
      text-decoration: none;
      color: #FFF;
      transition: all 0.25s;
      background: #000;
      display: block;
      width: 100%;
      padding: 0;
      border: none;
      cursor: pointer;
    }

    .lest-talk-container:hover {
      background: #FFF;
      color: #000;
      transition: all 0.25s;
    }

    .arrow-container .arrow-path {
      fill: #FFF;
      transition: all 0.25s;
    }

    .lest-talk-container:hover .arrow-container .arrow-path {
      fill: #000;
      transition: all 0.25s;
    }

    .lest-talk-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      border-top: 1px solid #ffffff21;
      border-bottom: 1px solid #ffffff21;
    }

    h2 {
      font-size: clamp(48px, 6.25vw, 120px);
      margin: 0;
      padding: 0;
      font-weight: 300;
    }

  </style>
  